import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import hyderabadImg from "../../assets/images/charmin.png";
import amsterdamImg from "../../assets/images/amstrdm.png";
import chicagoImg from "../../assets/images/usa.png";
const LOCATIONS = [
  {
    city: "Hyderabad",
    country: "India",
    tag: "APAC Delivery Hub",
    badge: "HQ & Engineering",
    description:
      "As the heart of our operations, our India office is a vibrant center for innovation, technology, and development. Home to our expert teams of engineers, developers, and staffing team.",
    address: {
      building: "Mahaveer The Watermark",
      area: "Whitefields, HITEC City",
      postal: "Hyderabad, Telangana 500081",
    },
    image: hyderabadImg,
    mapLink: "/",
  },
  {
    city: "Amsterdam",
    country: "Netherlands",
    tag: "EMEA Headquarters",
    badge: "Strategy & Advisory",
    description:
      "Our Netherlands office serves as a critical hub for our European operations. Positioned at the crossroads of innovation and commerce, this location delivers tailored enterprise solutions.",
    address: {
      building: "Radarweg 29",
      area: "Sloterdijk Business Hub",
      postal: "1043 NX, Amsterdam",
    },
    image: amsterdamImg,
    mapLink: "/",
  },
  {
    city: "Chicago",
    country: "USA",
    tag: "Americas Hub",
    badge: "Client Engagement",
    description:
      "Situated in the United States, our office caters to North American clients, providing local support, strategic solutions, and agile digital transformation delivery.",
    address: {
      building: "1701 E Woodfield Rd",
      area: "Corporate Center",
      postal: "Schaumburg, IL 60173",
    },
    image: chicagoImg,
    mapLink: "/",
  },
];

export default function AboutLoaction() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-[#fafbfc] text-[#000036] overflow-hidden">
      <div className="mx-auto 3xl:w-4/5 lg:w-11/12 px-6 lg:px-12 flex flex-col justify-center items-center relative z-10">
        <div className="mb-16 flex max-w-4xl flex-col items-center text-center md:mb-20">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-4 inline-flex items-center gap-2 rounded-full  px-3.5 py-1.5 backdrop-blur-md"
          >
            <span className="text-[11px] font-bold uppercase tracking-[0.2em] px-6 lg:px-0 text-slate-700">
              Meet our team of experts
            </span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.08 }}
            className="font-display text-3xl sm:text-4xl md:text-5xl font-bold px-6 lg:px-0 tracking-tight text-slate-950 "
          >
            Our{" "}
            <span className="italic font-serif font-normal text-[#5dc9f0]">
              Location
            </span>
          </motion.h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-8 items-stretch">
          {LOCATIONS.map((loc, idx) => (
            <motion.div
              key={loc.city}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="group relative flex flex-col justify-between rounded-xl h-full overflow-hidden bg-white border border-slate-200/90  transition-all"
            >
              <div className="">
                <div className="relative aspect-[16/10] w-full rounded-xl border border-slate-100 flex items-center justify-center overflow-hidden">
                  <img
                    src={loc.image}
                    alt={`${loc.city} landmark illustration`}
                    className="relative z-10 max-h-48 w-auto object-contain  transition-all duration-500 group-hover:scale-105"
                  />
                </div>
                <div className=" bg-[#000036] md:p-8 p-6 h-full">
                  <h3 className="font-serif text-2xl sm:text-3xl font-normal tracking-tight text-white group-hover:text-[#3579be] transition-colors duration-200">
                    {loc.city},{" "}
                    <span className="font-light text-white text-xl">
                      {loc.country}
                    </span>
                  </h3>
                  <p className="mt-4 text-base text-white font-normal leading-relaxed">
                    {loc.description}
                  </p>
                  <div className="mt-8 pt-5 border-t border-slate-100 flex items-end justify-between gap-2">
                    <div className="space-y-0.5">
                      <div className="flex items-center gap-1.5 text-ms font-bold uppercase tracking-wider text-white mb-1">
                        <span>Office Location</span>
                      </div>
                      <p className="text-base font-semibold text-[#000036]">
                        {loc.address.building}
                      </p>
                      <p className="text-base text-white">{loc.address.area}</p>
                      <p className="text-base text-white">
                        {loc.address.postal}
                      </p>
                    </div>
                    <a
                      href={loc.mapLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`View ${loc.city} office on Google Maps`}
                      className="h-10 w-10 rounded-full border border-slate-200 bg-slate-50 flex items-center justify-center text-slate-600 transition-all duration-300 group-hover:bg-[#000036] group-hover:text-white group-hover:border-[#000036] shadow-xs shrink-0"
                    >
                      <ArrowUpRight
                        size={16}
                        className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
